<template>
  <div class="top-panel">
    <v-app-bar color="blue darken-2" flat dark>
      <!-- Lado izquierdo -->
      <div class="left-section">
        <h2 class="title font-weight-light mr-0 mb-0">DATOS</h2>
        <!--h2 class="font-weight-light mr-0 mb-0">DATOS</h2-->


        <!-- Year Picker -->
        <YearPicker @year-changed="onYearChanged" />
      </div>

      <!-- Lado derecho: botones -->
      <div class="tabs-section">
        <v-btn
          v-for="(tab, index) in tabs"
          :key="index"
          :color="activeTab === index ? 'blue lighten-5' : 'blue darken-1'"
          :class="[
            'top-nav-btn',
            activeTab === index ? 'black--text' : 'white--text'
          ]"
          @click="navigateTo(tab, index)"
        >
          <span class="tab-label">
            {{ tab.label }}
          </span>

          <v-icon class="tab-icon">
            {{ tab.icon }}
          </v-icon>


        </v-btn>
      </div>

      <!--v-spacer></v-spacer-->
    </v-app-bar>
  </div>
</template>

<script>
import YearPicker from "@/components/YearPicker.vue";

export default {
  name: "TopPanel",

  props: {
    activeTab: {
      type: Number,
      default: -1,
    },
  },

  components: {
    YearPicker,
  },

  data() {
    return {
      tabs: [
        { label: "Caracterización", icon: "mdi-account-details", path: "/caracterizacion/" },
        { label: "Rating", icon: "mdi-star-circle", path: "/rating/" },
        { label: "Materia prima", icon: "mdi-barley", path: "/materiaprima/" },
      ],
    };
  },

  methods: {
    onYearChanged(newYear) {
      this.$emit("year-changed", newYear);
    },

    navigateTo(tab, index) {
      this.$emit("update:activeTab", index); // notifica a la vista
      this.$router.push(tab.path);
    },
  },
};
</script>

<style scoped>
.top-panel {
  display: flex;
  flex-wrap: wrap;            /*  Permite que los botones bajen a otra fila */
  align-items: center;
  justify-content: space-between;
  background: #3f72cd;
  padding: 0px 20px;          /*  controla el alto del topanel */
  border-radius: 4px;
  gap: 10px;                 /*  separa YearPicker de los botones */
  width: 100%;
}

/* === Sección izquierda (DATOS + Año) === */
.left-section {
  display: flex;
  align-items: center;
  gap: 0px;                 /*  controla distancia entre DATOS y boton yearpicker */
}

.title {
  margin: 0;
  padding: 0;
  line-height: 40px;
  font-size: clamp(16px, 1.2vw, 22px);
}

/* === Contenedor de botones === */
.tabs-section {
  display: flex;
  align-items: center;
  flex-wrap: wrap;         /* 🔥 importante: si no cabe, baja a segunda fila */
  gap: 12px; /* separación entre botones */
}

/* === Botones de navegación === */
.top-nav-btn {
  width: 180px;       /* ancho uniforme */
  height: 40px;       /* altura aumentada para más presencia */
  margin-left: 12px;        /* 🔥 separación entre botones */
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.85rem;
  padding: 0 10px;
  border-radius: 6px;
  text-transform: none !important; /* evita mayúsculas forzadas */
}

/* === Responsivo: en tablets ajustar tamaño === */
@media (max-width: 1100px) {
  .top-nav-btn {
    width: 130px;
    height: 38px;
    font-size: 0.78rem;
  }
}
/* --- Desktop: mostrar texto, ocultar icono --- */
.tab-icon {
  display: none;
}

.tab-label {
  display: inline;
}

/* 🔥 Ajuste extremo para pantallas muy pequeñas (<750px) */
@media (max-width: 750px) {

  /* Reducimos padding de todo el panel */
  .top-panel {
    padding: 6px 10px !important;
  }

  /* Reducimos la separación entre "DATOS" y YearPicker */
  .left-section {
    gap: 4px !important;   /* antes era 12px */
  }

  /* Achicamos la palabra DATOS */
  .title {
    font-size: 16px !important;
  }

  /* YearPicker más compacto */
  .left-section .v-select {
    max-width: 90px !important;
    font-size: 13px !important;
  }

  /* Botones de tabs convertidos a iconos compactos */
  .top-nav-btn {
    flex: 1 1 0 !important;  /* 🔥 se reparten el espacio */
    width: 100% !important;      
    height: 40px !important;
    min-width: 0 !important;
    padding: 0 !important;
    border-radius: 6px !important;
  }

  .tab-icon {
    font-size: 20px !important; /* 🔥 iconos más pequeños */
    display: inline-block !important;
  }

  /* Ocultamos el texto completamente, pero ya debería quedar oculto */
  .tab-label {
    display: none !important;
  }

  /* Alineamos mejor los botones */
  .tabs-section {
    width: 100%;
    display: flex;
    gap: 6px !important;
    flex-grow: 1;
    justify-content: space-between;
    
  }
}

</style>
